import Button from 'antd/lib/button';
import { useState } from 'react'
import { removeUser } from '../../Redux/Actions/authActions'
import { useDispatch } from 'react-redux';

const Count = () => {
    const dispatch = useDispatch()
    const [name, setName] = useState()
    const [count, setCount] = useState(0)
    const [wordCount, setWord] = useState(0)
    const [obj, setObj] = useState([])
    // const [wordC, setWordC] = useState([])

    const upDate = (e) => {
        setName(e?.target?.value)
        setCount(e?.target?.value?.length)
        setWord(e?.target?.value?.trim()?.split(' ')?.length)

        let wordArray = e?.target?.value?.trim()?.split(' ');
        for (var v of wordArray) {
            v = v?.toLowerCase();
            if (!obj[v]) {
                obj[v] = 1
            } else {
                obj[v]++
            }
        }
        setObj({ ...obj })

        // // let rep = setWord
        // // for (var v of rep) {
        // // let wordArray = e?.target?.value?.trim()?.split(' ');
        // for (var v of wordArray) {
        //     v = v?.toLowerCase();
        //     if (wordC[v] === setWord[v]) {
        //         console.log('repeated');
        //     }
        //     setWordC({ ...wordC })
        // }
    }

    return (
        <div >
            <div style={{
                display: 'flex', justifyContent: 'right', backgroundColor: 'grey'
            }}>
                <Button type='primary' onClick={() => dispatch(removeUser())} style={{ borderRadius: '50px', height: '50px', width: '50px', display: 'flex', alignItems: 'center', textAlign: 'center', marginRight: '15px', position: 'relative', fontSize: '10px' }}>Logout</Button>
            </div >
            <h1>{name}</h1>
            <input placeholder='Type here' autoFocus onChange={upDate} />
            <p><b>Alphabatical Count: </b>{count}</p>
            <p><b>Word Count: </b>{wordCount}</p><br />
            <div>{Object.entries(obj)?.map((v, i) => {
                return <p key={i}>{`${v[0]?.charAt(0)?.toUpperCase()}${v[0]?.slice(1,)}:${v[1]}`}</p>
            })}</div>
        </div>
    )
}

export default Count